import React, { useState, useEffect, useRef, useLayoutEffect, useMemo } from 'react';
import TimeOffRequestCanvas from '../../common/OffCanvas';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import TimeOffRequestAddUpdate from "./TimeOffRequestAddUpdate";
import CustomPagination from "../../common/Pagination";
import moment from 'moment';
import { ShowToast } from '../../common/Toastr';
import { getPageSizeArray, getStatusConfig, paginationStyles } from '../../common/timeLiveFunction';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import clsx from 'clsx';
import { Dropdown } from 'react-bootstrap';
import Select, { StylesConfig } from 'react-select';
import { KTSVG, KTIcon, useDebounce } from '../../_metronic/helpers';
import TimeOffRequestDetail from './TimeOffRequestDetail';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    getTimeOffRequestList, getTimeOffRequestStatusList, updateAccountEmployeeTimeOffRequestId, deleteAccountEmployeeTimeOffRequest,
    updatePagination, updateSearchPagination, updateIsLoading, updateSorting,setPageSize
} from "./timeoffrequestSlice";
//import { isReload } from "../../features/approvals/timeOffApproval/TimeOffApprovalSlice";
import { getPagePermissionsAsync } from '../../common/GlobalSlice';
import { resetAttachmentList } from '../../features/attachment/AttachmentSlice';
import { AttachmentUpload } from '../../features/attachment/AttachmentUpload';
import GetAttachments from '../../features/attachment/AttachmentItem';
import Loader from '../../common/Loader';
import PageSizeSelect from '../../common/PageSizeSelect';
import { formatDateWithDateAndMonthName, formatHoursOff, getValueFromResource, determineCommaSeprater } from '../../common/timeLiveFunction';
import { TimeOffRequestFilter } from './TimeOffRequestFilter';
import OffCanvas from '../../common/OffCanvas';
import { ColumnDef, SortingState, ColumnOrderState, ColumnSizingState } from '@tanstack/react-table';
import DataTable from '../../common/DataTable';
import TimeOffStatusGridView from './TimeOffStatusGridView';
import ActionsMenu, { ActionMenuItem } from '../../common/ActionMenu';

const ACTIONS_COL_WIDTH = 120
const TimeOffRequest = () => {
    const [tab, setTab] = useState('TimeOffList');
    const [timeOffRequestDetailViewId, setTimeOffRequestDetailViewId] = useState('');
    // const [hoveredColumn, setHoveredColumn] = useState(null);
    const [isHeaderShown, setIsHeaderShown] = useState<boolean>(true);
    // const { sessionAccountEmployeeId, pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, maxMenuHeight, isShowTimeOffInDays, cultureInfoName, enableUploadFeature } = useAppSelector((state) => state.globalState);
    const { decimalPlaces, sessionAccountEmployeeId, pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, maxMenuHeight, isShowTimeOffInDays, cultureInfoName, enableUploadFeature, accountPreferenceList } = useAppSelector((state) => state.globalState);
    const { isReloadStatus, TimeOffStatus, timeoffrequestList, timeoffrequeststatusList, startRec, pageSize, pageNo, search, totalItems, isSearch, isLoading, isLockSubmittedRecords, isLockApprovedRecords,
        sortOrder, sortColumn ,recordsFiltered} = useAppSelector((state) => state.timeoffrequest);
        const { isReload } = useAppSelector((state) => state.timeOffApproval);
        const showConsumedHours = accountPreferenceList[0]?.IsShowConsumedHours ?? false;
    const [showOffCanvas, setShowOffCanvas] = useState(false);     
    const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);   
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const [statusViewMode, setStatusViewMode] = useState<'grid' | 'list'>('list');
    const [statusSorting, setStatusSorting] = useState<SortingState>([]);
    const [statusColumnOrder, setStatusColumnOrder] = useState<ColumnOrderState>(['timeOffType', 'earnedHours', ...(showConsumedHours ? ['consumeHours'] : []), 'availableHours']);
    const [statusColumnSizing, setStatusColumnSizing] = useState<ColumnSizingState>({});
    const [requestSorting, setRequestSorting] = useState<SortingState>([]);
    const [requestColumnOrder, setRequestColumnOrder] = useState<ColumnOrderState>(['timeOffType', 'description', 'hoursOff', 'daysOff', 'beginDate', 'endDate', 'status']);
    const [requestColumnSizing, setRequestColumnSizing] = useState<ColumnSizingState>({});
    const addUpdateRef = useRef<any>(null); 
      const offCanvasList = [
        {
          "name": getValueFromResource('Time Off Request', dispatch, t),
          "width": "500px",
          "componentName": < TimeOffRequestAddUpdate ref={addUpdateRef}/>
        },
        {
          "name": getValueFromResource('Filters', dispatch, t),
          "width": "500px",
          "componentName": < TimeOffRequestFilter />
        }
      ];
    const [selectedOffCanvas, setSelectedOffCanvas] = useState(offCanvasList[0]);
    // const isCommaSeprater = determineCommaSeprater(cultureInfoName.toString());
      let isCommaSeprater = determineCommaSeprater(cultureInfoName.toString());
    
    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        }
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);


    const debouncedSearchTerm = useDebounce(search, 500);
    useEffect(() => {
        if (!isFirstTimeLoad) {
        dispatch(getTimeOffRequestList());
        dispatch(updateSearchPagination(debouncedSearchTerm));
    }
    }, [debouncedSearchTerm]);

    useEffect(() => {
        dispatch(getTimeOffRequestList());
        startRec == 0 && dispatch(getTimeOffRequestStatusList(sessionAccountEmployeeId))
        setTab('TimeOffList');
        setIsFirstTimeLoad(false);
    }, [pageNo, pageSize, sortOrder, sortColumn, isReload, isReloadStatus]);

    const onHandleSearch = (event: any) => {
        const value = event.target.value;
        dispatch(updateSearchPagination(value));
    };

     const handleOnClickEvent = (selectedObject: any) => {
       dispatch(updateAccountEmployeeTimeOffRequestId(''));
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    
      }
   
    // const generalObject = {
    //     "name": getValueFromResource('Time Off Request', dispatch, t),
    //     "width": "600px",
    //     "componentName": <TimeOffRequestAddUpdate />
    // }
   
    const handlePageSizeChange = (event: any) => {
        const { value } = event;
        dispatch(setPageSize(Number(value)));
        dispatch(getTimeOffRequestList());
    }

    const handlePageChange = (pageNumber: any) => {
        let objects = {
            "startRec": (pageNumber - 1) * Number(pageSize),
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    }

    const onEditTimeOffRequest = (id: string) => {
        console.log("onEditTimeOffRequest", id)
        dispatch(updateAccountEmployeeTimeOffRequestId(id));
        setSelectedOffCanvas(offCanvasList[0]);
        // setShowOffCanvas(true);
        addUpdateRef.current?.refreshData();
    }

    // const onAddTimeOffRequest = () => {
    //     dispatch(updateAccountEmployeeTimeOffRequestId(''));
    // }

    const onDeleteTimeOffRequest = (id: string) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(updateIsLoading(true));
                    dispatch(deleteAccountEmployeeTimeOffRequest(id)).then((result) => {
                        if (result.payload.StatusCode == '200') {
                            ShowToast('Success', result.payload.ResponseMessage, "success", "toast-top-right");
                        } else {
                            ShowToast('Error', "Time off cannot be deleted successfully.", "error", "toast-top-right");
                        }
                    }).catch((error) => {
                    });
                }
            })
            .catch((error) => {
            });
    }

    //Attachment Work
    const modalAttachmentRef = useRef<any>(null);
    const [tempAttachmentId, setTempAttachmentId] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [accountEmployeeTimeOffRequestId, setAccountEmployeeTimeOffRequestId] = useState(null);
    const attachmentUploadClearRef = useRef<any>(null);
    useEffect(() => {
        if (modalIsOpen) {
            if (modalAttachmentRef.current) {
                modalAttachmentRef.current.click();
            }
        }
    }, [modalIsOpen]);
    const handleAttachment = (accountEmployeeTimeEntryPeriodId: any) => {
        dispatch(resetAttachmentList());
        setModalIsOpen(true);
    }
    const updateTempAttachmentId = (value: any) => {
        setTempAttachmentId(value);
    };
    //Attachment Work 
    const navigateToAudit = (AccountEmployeeTimeOffRequestId: any) => {
        const obj = {
            Id: AccountEmployeeTimeOffRequestId,
            TableName: 'AccountEmployeeTimeOffRequest',
            Title: 
            // t('Time Off Request Audit')
            getValueFromResource('Time Off Request Audit', dispatch, t)
        }
        // navigate('/accountaudit', { state: { obj } });
        navigate(`/accountaudit/${AccountEmployeeTimeOffRequestId}`, { state: { obj } })

    }

    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
   
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "startRec": 0,
            "pageSize": pageSize,
            "pageNo": 1
        }
        dispatch(updateSorting(objects));
    }
    
    const timeOffStatusColumns = useMemo<ColumnDef<any>[]>(() => [
            {
                id: 'timeOffType',
                accessorKey: 'AccountTimeOffType',
                header: () => getValueFromResource('Time Off Type', dispatch, t),
                cell: ({ getValue }) => (
                    <span className="text-dark fw-bold d-block" style={{ fontSize: 13 }}>
                        {getValue() as string}
                    </span>
                ),
                enableSorting: true,
                size: 220, minSize: 150, maxSize: 400,
            },
            {
                id: 'earnedHours',
                accessorKey: 'Earned',
                header: () => getValueFromResource(`Earned  ${isShowTimeOffInDays ? 'Days' : 'Hours'}`, dispatch, t),
                cell: ({ row }) => (
                    <span className="text-gray-800 d-block">
                        {`${formatHoursOff(Number(row.original.Earned), 2, cultureInfoName.toString())} ${isShowTimeOffInDays ? 'Days' : 'Hours'}`}
                    </span>
                ),
                enableSorting: true,
                size: 160, minSize: 120, maxSize: 260,
            },
        ...(showConsumedHours ? [{
            id: 'consumeHours',
            accessorKey: 'Consume',
            header: () => getValueFromResource(`Consumed ${isShowTimeOffInDays ? 'Days' : 'Hours'}`, dispatch, t),
            cell: ({ row }: any) => (
                <span className="text-gray-800 d-block">
                    {`${formatHoursOff(Number(row.original.Consume), 2, cultureInfoName.toString())} ${isShowTimeOffInDays ? 'Days' : 'Hours'}`}
                </span>
            ),
            enableSorting: true,
            size: 160,
            minSize: 120,
            maxSize: 260,
        }] : []),
            {
                id: 'availableHours',
                accessorKey: 'Available',
                header: () => getValueFromResource(`Available  ${isShowTimeOffInDays ? 'Days' : 'Hours'}`, dispatch, t),
                cell: ({ row }) => (
                    <span className="text-gray-800 d-block">
                        {`${formatHoursOff(Number(row.original.Available), 2, cultureInfoName.toString())} ${isShowTimeOffInDays ? 'Days' : 'Hours'}`}
                    </span>
                ),
                enableSorting: true,
                size: 160, minSize: 120, maxSize: 260,
            },
        ], [dispatch, t, cultureInfoName]);
    
        const timeOffRequestListColumns = useMemo<ColumnDef<any>[]>(() => [
            {
                id: 'timeOffType',
                accessorKey: 'AccountTimeOffType',
                header: () => getValueFromResource('Time Off Type', dispatch, t),
                cell: ({ getValue }) => (
                    <a className='text-dark fw-bold d-block'>
                        {getValue() as string}
                    </a>
                ),
                enableSorting: true,
                size: 220, minSize: 150, maxSize: 400,
            },
             {
                id: 'description',
                accessorKey: 'Description',
                header: () => getValueFromResource('Description', dispatch, t),
                cell: ({ getValue }) => (
                    <span className="text-gray-800 d-block">
                        {getValue() as string}
                    </span>
                ),
                enableSorting: true,
                size: 160, minSize: 120, maxSize: 260,
            },
            {
                id: 'hoursOff',
                accessorKey: 'HoursOff',
                header: () => getValueFromResource('Hours Off', dispatch, t),
                cell: ({ row }) => (
                    <span className="text-gray-800 d-block">
                        {`${formatHoursOff(Number(row.original.HoursOff), 2, cultureInfoName.toString())} Hours`}
                    </span>
                ),
                enableSorting: true,
                size: 160, minSize: 120, maxSize: 260,
            },
            {
                id: 'daysOff',
                accessorKey: 'DayOff',
                header: () => getValueFromResource('Days Off', dispatch, t),
                cell: ({ row }) => (
                    <span className="text-gray-800 d-block">
                        {`${formatHoursOff(Number(row.original.DayOff), 2, cultureInfoName.toString())} Days`}
                    </span>
                ),
                enableSorting: true,
                size: 160, minSize: 120, maxSize: 260,
            },
            {
                id: 'beginDate',
                accessorKey: 'StartDate',
                header: () => getValueFromResource('Begin Date', dispatch, t),
                cell: ({ row }) => (
                    <span className="text-gray-800 d-block">
                        {formatDateWithDateAndMonthName(row.original.StartDate, cultureInfoName.toString())}
                    </span>
                ),
                enableSorting: true,
                size: 160, minSize: 120, maxSize: 260,
            },
            {
                id: 'endDate',
                accessorKey: 'EndDate',
                header: () => getValueFromResource('End Date', dispatch, t),
                cell: ({ row }) => (
                    <span className="text-gray-800 d-block">
                        {formatDateWithDateAndMonthName(row.original.EndDate, cultureInfoName.toString())}
                    </span>
                ),
                enableSorting: true,
                size: 160, minSize: 120, maxSize: 260,
            },
            {
                id: 'status',
                accessorKey: 'TimeOffStatus',
                header: () => getValueFromResource('Status', dispatch, t),
    
                cell: ({ row }) => {
                    const status = getStatusConfig(row.original.TimeOffStatus);
    
                    return (
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 5,
                                background: status.bg,
                                color: status.color,
                                borderRadius: 20,
                                padding: '2px 8px',
                                fontSize: 11,
                                fontWeight: 500,
                                whiteSpace: 'nowrap',
                            }}
                        >
                            <span
                                style={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: '50%',
                                    background: status.dot,
                                    display: 'inline-block',
                                    flexShrink: 0,
                                }}
                            />
    
                            {status.label}
                        </span>
                    );
                },
    
                enableSorting: true,
                size: 160,
                minSize: 120,
                maxSize: 260,
            },
    
        ], [dispatch, t, cultureInfoName]);
    return (
        <>
            {modalIsOpen && (
                <>
                    <div className="modal drawer-overlay" id="attachmentModel" data-bs-backdrop="false">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content rounded">
                                <div className='modal-header pb-2'>
                                    <h5>
                                        {/* {t(`Attachment`)} */}
                                        {getValueFromResource('Attachment',dispatch, t)}

                                        </h5>
                                    <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={() => setModalIsOpen(false)}>
                                        <KTIcon iconName='cross' className='fs-1' />
                                    </div>
                                </div>
                                <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                                    <AttachmentUpload
                                        Id={accountEmployeeTimeOffRequestId}
                                        onupdateTempAttachmentId={updateTempAttachmentId}
                                        clearRef={attachmentUploadClearRef}
                                        AccountAttachmentTypeId={3}
                                    />
                                    <GetAttachments Id={accountEmployeeTimeOffRequestId} AccountAttachmentTypeId={3} IsShowEmployeeInformation={false} />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight  me-2 btn-sm fs-7"
                                        data-bs-dismiss="modal"
                                        onClick={() => setModalIsOpen(false)}
                                    >
                                        {/* {t("Cancel")} */}
                                        {/* {getValueFromResource('Cancel',dispatch, t)} */}
                                         {getValueFromResource('Close',dispatch, t)}

                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button ref={modalAttachmentRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#attachmentModel">
                        {/* {t('Launch demo modal')} */}
                        {getValueFromResource('Launch demo modal',dispatch, t)}

                    </button>
                </>
            )}
            {isLoading && <Loader />}
            <div className="card card-custom admin-card">
                {IsList &&
                    <>
                        <div className="card-header card-drop sticky-top bg-white fixed-top">
                            <h3 className="card-title fw-bold headerTitle">
                                {/* {t('Time Off Request List')} */}
                                {getValueFromResource('Time Off Request List',dispatch, t)}

                                </h3>
                            {tab === 'TimeOffList' && <div className="card-toolbar align-items-center">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        value={search}
                                        onChange={onHandleSearch}
                                        placeholder =
                                        // {t('Search')}
                                        {getValueFromResource('Search',dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">                                   
                                    <PageSizeSelect onChange={handlePageSizeChange} />
                                </div>
                               
                            {(timeoffrequestList.length > 0) && (
                                <>
                                    <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                    <div>
                                        <CustomPagination
                                            currentPage={pageNo}
                                            onPageChange={handlePageChange}
                                            pageSize={pageSize}
                                            totalItems={totalItems}
                                            start={startRec}
                                            t={t}
                                            recordsFiltered={recordsFiltered}
                                        >
                                        </CustomPagination>

                                    </div>
                                </>
                            )}
                           <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                            <a id="kt_OffCanvas"
                                         className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                         data-tooltip-id="tooltip-Description" data-t  ooltip-content={getValueFromResource('Filters',dispatch, t)}
                                         onClick={() => handleOnClickEvent(offCanvasList[1])}
                                         data-tooltip-place="bottom">
                                         <i className="bi bi-filter fs-3 iconColor" ></i>
                                       </a>
                                {IsAdd &&
                                    <>
                                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                        <button
                                            id="kt_OffCanvas"
                                            type="button"
                                            className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                                            onClick={() => handleOnClickEvent(offCanvasList[0])}
                                        >
                                             {/* {t('Add Time Off Request')} */}
                                             {getValueFromResource('Add Time Off Request',dispatch, t)}
                                        </button>
                                    </>
                                }
                            </div>}
                            {tab === 'TimeOffStatus' && (
                                <div
                                    className="d-flex align-items-center p-1 rounded"
                                    style={{
                                        height: 38,
                                        backgroundColor: '#f1f3f5',
                                        border: '1px solid #e1e5e9',
                                        gap: 2
                                    }}
                                >
                                    <button
                                        type="button"
                                        className={clsx(
                                            'btn btn-sm d-flex align-items-center justify-content-center',
                                            'rounded',
                                            {
                                                'bg-white text-primary shadow-sm': statusViewMode === 'list',
                                                'text-gray-600': statusViewMode !== 'list'
                                            }
                                        )}
                                        style={{
                                            height: 30,
                                            minWidth: 38,
                                            padding: '0 10px',
                                            border: 'none',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onClick={() => setStatusViewMode('list')}
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content={getValueFromResource('List View', dispatch, t)}
                                        data-tooltip-place="bottom"
                                    >
                                        <i className="bi bi-list-ul fs-5"></i>
                                    </button>

                                    <button
                                        type="button"
                                        className={clsx(
                                            'btn btn-sm d-flex align-items-center justify-content-center',
                                            'rounded',
                                            {
                                                'bg-white text-primary shadow-sm': statusViewMode === 'grid',
                                                'text-gray-600': statusViewMode !== 'grid'
                                            }
                                        )}
                                        style={{
                                            height: 30,
                                            minWidth: 38,
                                            padding: '0 10px',
                                            border: 'none',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onClick={() => setStatusViewMode('grid')}
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content={getValueFromResource('Grid View', dispatch, t)}
                                        data-tooltip-place="bottom"
                                    >
                                        <i className="bi bi-grid-3x3-gap fs-5"></i>
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="card-body py-3">
                        <div className='d-flex justify-content-between align-items-center flex-wrap' style={{ marginTop: 8 }}>
                            <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist' style={{ marginTop: 8 }}>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'TimeOffList' })}
                                        onClick={() => setTab('TimeOffList')}
                                        role='tab'
                                        style={{ fontWeight: 500 }}
                                    >
                                        {/* {t("Time Off Request List")} */}
                                        {getValueFromResource('Time Off Request List',dispatch, t)}
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer`, { active: tab === 'TimeOffStatus' })}
                                        onClick={() => setTab('TimeOffStatus')}
                                        role='tab'
                                        style={{ fontWeight: 500 }}
                                    >
                                        {/* {t("Time Off Status")} */}
                                        {getValueFromResource('Time Off Status',dispatch, t)}

                                    </a>
                                </li>
                            </ul>
                        </div>
                            <div className='tab-content pt-0'>
                                <div className={clsx('tab-pane', { active: tab === 'TimeOffList' })}>
                                    <div className="table-responsive" style={{ marginTop: 8 }}>
                                    <DataTable
                                        data={timeoffrequestList}
                                        columns={timeOffRequestListColumns}
                                        sorting={requestSorting}
                                        onSortingChange={setRequestSorting}
                                        columnOrder={requestColumnOrder}
                                        onColumnOrderChange={setRequestColumnOrder}
                                        columnSizing={requestColumnSizing}
                                        onColumnSizingChange={setRequestColumnSizing}
                                        maxHeight="calc(100vh - 250px)"
                                        noDataMessage={getValueFromResource('No Record Found', dispatch, t)}
                                        droppableId="timeOffRequestListColumns"
                                        actions={{
                                            header: getValueFromResource('Actions', dispatch, t),
                                            width: ACTIONS_COL_WIDTH,
                                            render: (row) => {
                                                const canModify =
                                                    (isLockSubmittedRecords == false && row.original.TimeOffStatus == 'Submitted') ||
                                                    row.original.TimeOffStatus == 'Rejected' ||
                                                    (isLockApprovedRecords == false && row.original.TimeOffStatus == 'Approved');

                                                const items: ActionMenuItem[] = [
                                                    {
                                                        id: 'kt_OffCanvas',
                                                        label: getValueFromResource('Edit', dispatch, t),
                                                        visible: !!(canModify && IsEdit),
                                                        icon: (
                                                            <div
                                                                id="kt_OffCanvas"
                                                                className="menu-item me-lg-0"
                                                                onClick={() => { onEditTimeOffRequest(row.original.AccountEmployeeTimeOffRequestId) }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('Edit', dispatch, t)}
                                                                </span>
                                                            </div>
                                                        )
                                                    },
                                                    {
                                                        id: 'attachment',
                                                        label: getValueFromResource('View Attachment', dispatch, t),
                                                        visible: !!enableUploadFeature,
                                                        icon: (
                                                            <div
                                                                className="menu-item me-lg-0"
                                                                onClick={(event: any) => {
                                                                    event.preventDefault();
                                                                    setAccountEmployeeTimeOffRequestId(row.original.AccountEmployeeTimeOffRequestId);
                                                                    handleAttachment(1);
                                                                }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-paperclip fs-4 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('View Attachment', dispatch, t)}
                                                                </span>
                                                            </div>
                                                        )
                                                    },
                                                    {
                                                        id: 'viewDetail',
                                                        label: getValueFromResource('View Detail', dispatch, t),
                                                        icon: (
                                                            <div
                                                                ref={modelRef}
                                                                data-bs-toggle={"modal"}
                                                                data-bs-target="#timeOffRequestDetailModal"
                                                                className="menu-item me-lg-0"
                                                                onClick={() => { setTimeOffRequestDetailViewId(row.original.AccountEmployeeTimeOffRequestId) }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-bag fs-6 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {/* {`${t('View Detail')}`} */}
                                                                    {getValueFromResource('View Detail', dispatch, t)}
                                                                </span>
                                                            </div>
                                                        )
                                                    },
                                                    {
                                                        id: 'audit',
                                                        label: getValueFromResource('Audit', dispatch, t),
                                                        icon: (
                                                            <div
                                                                className="menu-item me-lg-0 "
                                                                onClick={() => navigateToAudit(row.original.AccountEmployeeTimeOffRequestId)}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-receipt fs-6 iconColor">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title custom-menu-fontsize">
                                                                    {getValueFromResource('Audit', dispatch, t)}
                                                                </span>
                                                            </div>
                                                        )
                                                    },
                                                    {
                                                        id: 'delete',
                                                        label: getValueFromResource('Delete', dispatch, t),
                                                        visible: !!(canModify && IsDelete),
                                                        danger: true,
                                                        divider: true,
                                                        icon: (
                                                            <div
                                                                className="menu-item me-lg-0"
                                                                onClick={() => { onDeleteTimeOffRequest(row.original.AccountEmployeeTimeOffRequestId) }}
                                                            >
                                                                <span className="menu-icon custom-menu mb-2">
                                                                    <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                                <span className="menu-title delete-menu custom-menu-fontsize">
                                                                    {getValueFromResource('Delete', dispatch, t)}
                                                                </span>
                                                            </div>
                                                        )
                                                    },
                                                ];

                                                return (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                                        <ActionsMenu
                                                            items={items}
                                                            tooltipId="tooltip-Description"
                                                            tooltipContent={getValueFromResource('More', dispatch, t)}
                                                        />
                                                    </div>
                                                );
                                            },
                                        }}
                                    />
                                        {/* <table className="table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1" style={{ width: '100%' }}>
                                            <thead>
                                                <tr className="thHeading align-middle">
                                                    <th style={{ width: '20%' }}>
                                                        {getValueFromResource('Time Off Type',dispatch, t)}
                                                        {sortColumn === '1' ?
                                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                            </span>
                                                            :
                                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                            </>}
                                                    </th>
                                                    
                                                    <th style={{ width: '15%' }}>
                                                        {getValueFromResource('Hours Off',dispatch, t)}
                                                        {sortColumn === '3' ?
                                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                            </span>
                                                            :
                                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                            </>}
                                                    </th>
                                                    <th style={{ width: '15%' }}>
                                                        {getValueFromResource('Days Off',dispatch, t)}
                                                        {sortColumn === '4' ?
                                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                            </span>
                                                            :
                                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "4") }}>
                                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "4") }}>
                                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                            </>}
                                                    </th>
                                                <th style={{ width: '15%' }}>
                                                    {getValueFromResource('Begin Date', dispatch, t)}
                                                    {sortColumn === '5' ?
                                                        sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                                            <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                                            <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                        </span>
                                                        :
                                                        <><span className="cursor" onClick={() => { onHandleSorting("asc", "5") }}>
                                                            <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                            <span className="cursor" onClick={() => { onHandleSorting("desc", "5") }}>
                                                                <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                        </>}
                                                </th>
                                                <th style={{ width: '15%' }}>
                                                    {getValueFromResource('End Date', dispatch, t)}
                                                    {sortColumn === '6' ?
                                                        sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                                            <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                        </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                                            <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                        </span>
                                                        :
                                                        <><span className="cursor" onClick={() => { onHandleSorting("asc", "6") }}>
                                                            <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                            <span className="cursor" onClick={() => { onHandleSorting("desc", "6") }}>
                                                                <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                        </>}
                                                </th>
                                                <th style={{ width: '10%' }}>
                                                        {getValueFromResource('Status',dispatch, t)}
                                                        {sortColumn === '7' ?
                                                            sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "7") }}>
                                                                <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                            </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "7") }}>
                                                                <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                            </span>
                                                            :
                                                            <><span className="cursor" onClick={() => { onHandleSorting("asc", "7") }}>
                                                                <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                                <span className="cursor" onClick={() => { onHandleSorting("desc", "7") }}>
                                                                    <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                                        <span className="path1"></span>
                                                                        <span className="path2"></span>
                                                                    </i>
                                                                </span>
                                                            </>}
                                                    </th>
                                                <th style={{ width: '10%' }}>
                                                    
                                                </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {timeoffrequestList.length > 0 && timeoffrequestList.map((item: any, i: any) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <a className='text-dark fw-bold d-block'>
                                                                {item.AccountTimeOffType}
                                                            </a> */}
                                                            {/* <span style={{ color: '#7b8ba6', fontSize: 11 }}>
                                                                {`${moment.parseZone(item.StartDate).format('DD MMM yy')} - ${moment.parseZone(item.EndDate).format('DD MMM yy')}`}
                                                            </span> */}
                                                        {/* </td> */}
                                                       
                                                        {/* <td>
                                                            <span className="text-gray-800 d-block"> */}
                                                                {/* {`${isCommaSeprater ? item.HoursOff.toString().replace('.', ',')  : item.HoursOff} Hours`} */}
                                                                {/* {`${formatHoursOff(Number(item.HoursOff), 2, cultureInfoName.toString())} Hours`}
                                                            </span>
                                                        </td> */}
                                                        {/* <td>
                                                            <span className="text-gray-800 d-block"> */}
                                                                {/* {`${isCommaSeprater ? item.DayOff.toString().replace('.', ',') : item.DayOff} Days`} */}
                                                                {/* {`${formatHoursOff(Number(item.DayOff), 2, cultureInfoName.toString())} Days`}
                                                            </span>
                                                        </td> */}
                                                        {/* <td> */}
                                                            {/* {moment.parseZone(item.StartDate).format('DD MMM yy')} */}
                                                            {/* {formatDateWithDateAndMonthName(item.StartDate, cultureInfoName.toString())}
                                                        </td> */}
                                                        {/* <td> */}
                                                            {/* {moment.parseZone(item.EndDate).format('DD MMM yy')} */}
                                                            {/* {formatDateWithDateAndMonthName(item.EndDate, cultureInfoName.toString())}
                                                        </td>
                                                        <td>
                                                            <span className={clsx('timeOffStatus-td app-navbar-item badge', item.TimeOffStatusColor)}>
                                                                {item.TimeOffStatus}
                                                            </span>
                                                        </td>
                                                        <td className='text-center'>
                                                            <Dropdown
                                                                style={{ marginLeft: 1 }}
                                                                className={clsx('cursor-pointer symbol')}
                                                                data-kt-menu-attach='parent'
                                                                data-kt-menu-placement='bottom-end'
                                                            >
                                                                <Dropdown.Toggle
                                                                    variant="transparent"
                                                                    className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                                    data-tooltip-id="tooltip-Description"
                                                                    data-tooltip-content= */}
                                                                     {/* {t("More")} */}
                                                                    {/* {getValueFromResource('More',dispatch, t)}
                                                                    data-tooltip-place="top"
                                                                >
                                                                    <i className="bi bi-three-dots fs-7"></i>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                                    {((isLockSubmittedRecords == false && item.TimeOffStatus == 'Submitted') || (item.TimeOffStatus == 'Rejected') || (isLockApprovedRecords == false && item.TimeOffStatus == 'Approved')) && IsEdit &&
                                                                        <>
                                                                            <div className='menu-hover-bg-sec'>
                                                                                <Dropdown.Item
                                                                                    id="kt_OffCanvas"
                                                                                    className="menu-item me-lg-0"
                                                                                    onClick={() => { onEditTimeOffRequest(item.AccountEmployeeTimeOffRequestId) }}
                                                                                >
                                                                                    <span className="menu-icon custom-menu mb-2">
                                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                                            <span className="path1"></span>
                                                                                            <span className="path2"></span>
                                                                                        </i>
                                                                                    </span>
                                                                                    <span className="menu-title custom-menu-fontsize"> */}
                                                                                        {/* {`${t('Edit')}`} */}
                                                                                        {/* {getValueFromResource('Edit',dispatch, t)}
                                                                                        </span>
                                                                                </Dropdown.Item>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    {enableUploadFeature && 
                                                                    <div className='menu-hover-bg-sec'>
                                                                        <Dropdown.Item
                                                                            className="menu-item me-lg-0"
                                                                            onClick={(event: any) => {
                                                                                event.preventDefault();
                                                                                setAccountEmployeeTimeOffRequestId(item.AccountEmployeeTimeOffRequestId);
                                                                                handleAttachment(1);
                                                                            }}
                                                                        >
                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                <i className="bi bi-paperclip fs-4 iconColor">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                            <span className="menu-title custom-menu-fontsize"> */}
                                                                                {/* {`${t('View Attachment')}`} */}
                                                                                {/* {getValueFromResource('View Attachment',dispatch, t)}
                                                                                </span>
                                                                        </Dropdown.Item>
                                                                    </div>
                                                                    }
                                                                    <div className='menu-hover-bg-sec'>
                                                                        <Dropdown.Item
                                                                            ref={modelRef}
                                                                            data-bs-toggle={"modal"}
                                                                            data-bs-target="#timeOffRequestDetailModal"
                                                                            className="menu-item me-lg-0"
                                                                            onClick={() => { setTimeOffRequestDetailViewId(item.AccountEmployeeTimeOffRequestId) }}
                                                                        >
                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                <i className="bi bi-bag fs-6 iconColor">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                            <span className="menu-title custom-menu-fontsize"> */}
                                                                                {/* {`${t('View Detail')}`} */}
                                                                                {/* {getValueFromResource('View Detail',dispatch, t)}
                                                                                </span>
                                                                        </Dropdown.Item>
                                                                    </div>
                                                                    <div className='menu-hover-bg-sec'>
                                                                        <Dropdown.Item
                                                                            className="menu-item me-lg-0 "
                                                                            onClick={() => navigateToAudit(item.AccountEmployeeTimeOffRequestId)}
                                                                        >
                                                                            <span className="menu-icon custom-menu mb-2">
                                                                                <i className="bi bi-receipt fs-6 iconColor">
                                                                                    <span className="path1"></span>
                                                                                    <span className="path2"></span>
                                                                                </i>
                                                                            </span>
                                                                            <span className="menu-title custom-menu-fontsize"> */}
                                                                                {/* {`${t('Audit')}`} */}
                                                                                {/* {getValueFromResource('Audit',dispatch, t)}
                                                                                </span>
                                                                        </Dropdown.Item>
                                                                    </div>
                                                                    {((isLockSubmittedRecords == false && item.TimeOffStatus == 'Submitted') || (item.TimeOffStatus == 'Rejected') || (isLockApprovedRecords == false && item.TimeOffStatus == 'Approved')) && IsDelete &&
                                                                        <>
                                                                            <div className='separator mb-1 mt-1 opacity-75'></div>
                                                                            <div className='menu-hover-bg-danger'>
                                                                                <Dropdown.Item
                                                                                    className="menu-item me-lg-0"
                                                                                    onClick={() => { onDeleteTimeOffRequest(item.AccountEmployeeTimeOffRequestId) }}
                                                                                >
                                                                                    <span className="menu-icon custom-menu mb-2">
                                                                                        <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                                            <span className="path1"></span>
                                                                                            <span className="path2"></span>
                                                                                        </i>
                                                                                    </span>
                                                                                    <span className="menu-title delete-menu custom-menu-fontsize"> */}
                                                                                        {/* {`${t('Delete')}`} */}
                                                                                        {/* {getValueFromResource('Delete',dispatch, t)}
                                                                                        </span>
                                                                                </Dropdown.Item>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table> */}
                                        {/* {timeoffrequestList.length === 0 &&
                                            <div className=''>
                                                <p className='noDataFound'>
                                                    {getValueFromResource('No Record Found',dispatch, t)}
                                                    </p>
                                            </div>
                                        } */}
                                    </div>
                                </div>
                                <div className={clsx('tab-pane', { active: tab === 'TimeOffStatus' })}>
                                    <div className='row' style={{ width: '100%' }}>
                                    {statusViewMode === 'grid' ? (
                                        <TimeOffStatusGridView timeoffrequeststatusList={timeoffrequeststatusList} isShowTimeOffInDays={isShowTimeOffInDays} showConsumedHours={showConsumedHours}/>
                                    ) : (
                                        <div style={{ marginTop: 8 }}>
                                            <DataTable
                                                data={timeoffrequeststatusList}
                                                columns={timeOffStatusColumns}
                                                sorting={statusSorting}
                                                onSortingChange={setStatusSorting}
                                                columnOrder={statusColumnOrder}
                                                onColumnOrderChange={setStatusColumnOrder}
                                                columnSizing={statusColumnSizing}
                                                onColumnSizingChange={setStatusColumnSizing}
                                                maxHeight="calc(100vh - 250px)"
                                                noDataMessage={getValueFromResource('No Record Found', dispatch, t)}
                                                droppableId="timeOffStatusColumns"
                                            />
                                        </div>
                                    )}
                                    {/* {timeoffrequeststatusList.length > 0 && timeoffrequeststatusList.map((item: any, i: any) => (
                                            <div className='col-md-3 col-sm-3 col-xs-12 timeOffStatusParent' key={i}>
                                                <div className='timeOffStatusInfo'>
                                                  
                                                    <div className="row" style={{ height: 64 }}>
                                                        <div className="col-md-6" style={{ marginTop: 24 }}>
                                                            <a className="timeOff-hourStatus" style={{ paddingLeft: 16 }}>
                                                                {item.AccountTimeOffType}
                                                            </a>
                                                        </div>
                                                        <div className="col-md-6" style={{ marginTop: 12 }}>
                                                            <span className="tsNavBarInfoLabel" style={{ fontSize: 14 }}>
                                                                {t("Available")}
                                                            </span>
                                                            <div className="timeOffAvailableDays">
                                                                {isShowTimeOffInDays ? (
                                                                    <span>{`${formatHoursOff(Number(item.AvailableDay), 2, cultureInfoName.toString())} Days`}</span>
                                                                ) : (
                                                                    <span>{`${formatHoursOff(Number(item.Available), 2, cultureInfoName.toString())} Hours`}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="timeOffStatus-Separator"></div> */}
                                                    {/* <div className="row" style={{ marginLeft: 2 }}>
                                                        <div className="timeOffStatus-Footer">
                                                            <span className="timeOffConsumeLabel">
                                                                {isShowTimeOffInDays ? `${isCommaSeprater ? item.ConsumeDay.toString().replace('.', ',') : item.ConsumeDay} ${t("Days")}` : `${isCommaSeprater ? item.Consume.toString().replace('.', ',') : item.Consume} ${t("Hours")}`}
                                                            </span>
                                                            <div>
                                                                <span className="timeOffConsumeValue">{t("Consume")}</span>
                                                            </div>
                                                        </div>
                                                        <div className="timeOffStatus-Footer">
                                                            <span className="timeOffEarnedLabel">
                                                                {isShowTimeOffInDays ? `${isCommaSeprater ? item.EarnedDay.toString().replace('.', ',') : item.EarnedDay} ${t("Days")}` : `${isCommaSeprater ? item.Earned.toString().replace('.', ',') : item.Earned} ${t("Hours")}`}
                                                            </span>
                                                            <div>
                                                                <span className="timeOffConsumeValue">{t("Earned")}</span>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                {/* <div className="timeOffStatus-FooterContainer">
                                                    <div className="timeOffStatus-Footer">
                                                        <span className="timeOffConsumeLabel">
                                                                {isShowTimeOffInDays ? (
                                                                    <span>{`${formatHoursOff(Number(item.ConsumeDay), 2, cultureInfoName.toString())} Days`}</span>
                                                                ) : (
                                                                    <span>{`${formatHoursOff(Number(item.Consume), 2, cultureInfoName.toString())} Hours`}</span>
                                                                )}
                                                        </span>
                                                        <div>
                                                            <span className="timeOffConsumeValue">{t("Consume")}</span>
                                                        </div>
                                                    </div>
                                                    <div className="timeOffStatus-Footer">
                                                        <span className="timeOffEarnedLabel">
                                                                {isShowTimeOffInDays ? (
                                                                    <span>{`${formatHoursOff(Number(item.EarnedDay), 2, cultureInfoName.toString())} Days`}</span>
                                                                ) : (
                                                                    <span>{`${formatHoursOff(Number(item.Earned), 2, cultureInfoName.toString())} Hours`}</span>
                                                                )}
                                                        </span>
                                                        <div>
                                                            <span className="timeOffConsumeValue">{t("Earned")}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                    </div>                                                                   
                                            </div>
                                        ))}
                                        {timeoffrequeststatusList.length === 0 &&
                                            <div className='mt-4'>
                                                <p className='noDataFound'>
                                                   
                                                    {getValueFromResource('No Record Found',dispatch, t)}
                                                    </p>
                                            </div>
                                        } */}
                                    </div>
                                </div>
                               


                            </div>
                        </div>
                    </>
                }
            </div>
            {/* <TimeOffRequestCanvas obj={generalObject} /> */}
            <OffCanvas
        isOpen={showOffCanvas}
        onClose={() => setShowOffCanvas(false)}
        obj={selectedOffCanvas}
      />
            <TimeOffRequestDetail
                modelRef={modelRef}
                accountEmployeeTimeOffRequestId={timeOffRequestDetailViewId}
            />
        </>
    )
}

export default TimeOffRequest